export default {
  evaluation: {
    currentId: null,
    view: undefined,
  },
  adjustments: null,
}
